import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import ptBR from './locales/ptBR';
import en from './locales/en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { translation: ptBR },
      en: { translation: en },
    },
    fallbackLng: 'pt-BR',
    supportedLngs: ['pt-BR', 'en'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'quantumLanguage',
      convertDetectedLanguage: (language) =>
        String(language).toLowerCase().startsWith('pt') ? 'pt-BR' : 'en',
    },
  });

const updateDocumentLanguage = (language) => {
  document.documentElement.lang = language === 'en' ? 'en' : 'pt-BR';
};

updateDocumentLanguage(i18n.resolvedLanguage || i18n.language);
i18n.on('languageChanged', updateDocumentLanguage);

export default i18n;
